import type { FC, PropsWithChildren } from "react";
import Navbar from "../components/navbar";
import CompactSidebar from "../components/ResponsiveCompactSidebar";
import { SidebarProvider } from "../context/SidebarContext";
import classNames from "classnames";
import isSmallScreen from "../helpers/is-small-screen";

const NavbarSidebarLayout: FC<PropsWithChildren> = function ({ children }) {
  return (
    <div className="h-screen overflow-hidden bg-gray-50 dark:bg-gray-900">
      <SidebarProvider>
        <Navbar />
        <div className="flex items-start pt-16">
          <CompactSidebar />
          <MainContent>{children}</MainContent>
        </div>
      </SidebarProvider>
    </div>
  );
};

const MainContent: FC<PropsWithChildren> = function ({ children }) {
  const isMobile = isSmallScreen();
  const getMainContentClasses = () => {
    if (isMobile) {
      return "ml-0";
    }
    return "ml-20"; // Only offset for CompactSidebar (80px / 20rem)
  };

  return (
    <main
      className={classNames(
        "overflow-y-auto relative w-full h-full bg-gray-50 dark:bg-gray-900 transition-all duration-300",
        getMainContentClasses()
      )}

    >
      <div className="min-h-full">
        {children}
      </div>
    </main>
  );
};



export default NavbarSidebarLayout;